import React from 'react';

export const EInvoiceContext = React.createContext<{
  validateEInvoice: () => Promise<void>;
} | null>(null);
